import { getUserIdentity as getUserFromService } from "../../../../services/identity";
import { RECEIVE_USER_IDENTITY, IDENTITY_SDK_FAILURE } from "../constants";
import { SdkError } from "../../../../services/errors";

export const getUserIdentity = () => async dispatch => {
  let userIdentity;
  try {
    userIdentity = await getUserFromService();
  } catch (e) {
    if (e instanceof SdkError) {
      return dispatch({ type: IDENTITY_SDK_FAILURE });
    }
    throw e;
  }

  dispatch({ type: RECEIVE_USER_IDENTITY, payload: userIdentity });
};
